<!--
 * @Author: your name
 * @Date: 2020-04-13 10:56:45
 * @LastEditTime: 2020-04-13 18:57:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vueTest\houtai\src\page\layout.vue
 -->
<style>
.layout-container {
  height: 100vh;
}
.main-container {
  height: 100%;
}
.el-main {
  position: relative;
  background-color: #f5f7f9;
  padding: 0;
  overflow: auto;
}

.el-header,
.el-footer {
  background-color: white;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f1f1;
}
</style>
<style type="text/scss" src="@/assets/style/main.scss"></style>

 <template>
  <el-container class="layout-container">
    <!-- header部分 -->
    <el-header>
      <navtop></navtop>
    </el-header>
    <el-container class="main-container">
       <!-- aside部分 -->
      <leftNav :isCollapse="isCollapse" @toggleCollapse="isCollapse = !isCollapse"></leftNav>
      <el-main>
         <!-- main部分 -->
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>


 <script>
import navtop from "@/components/nav-top.vue";
import leftNav from "@/components/nav.vue";
export default {
  components: {
    navtop,
    leftNav
  },
  data() {
    return {
      isCollapse: false
    };
  },
  watch: {
    isCollapse() {
      this.$nextTick(() => {
        [100, 300, 600].forEach(t => {
          setTimeout(() => window.dispatchEvent(new Event("resize")), t);
        });
      });
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/page/layout.vue